import { useCallback } from 'react';
import { usePlayerContext } from '../PlayerContext';
import { useStore } from '../hooks/useStore';
import { FullscreenEnterIcon, FullscreenExitIcon } from '../icons';
import { Tooltip } from './Tooltip';
import styles from './FullscreenBtn.module.css';

export function FullscreenBtn() {
  const { store, eventBus } = usePlayerContext();
  const isFullscreen = useStore(store, useCallback(s => s.isFullscreen, []));

  const handleClick = useCallback(() => {
    eventBus.emit('fullscreen:change', !store.getState().isFullscreen);
  }, [eventBus, store]);

  return (
    <div className={styles.wrapper}>
      <button
        type="button"
        className={`${styles.btn}${isFullscreen ? ` ${styles.fs}` : ''}`}
        onClick={handleClick}
      >
        <span className={styles.iconEnter}><FullscreenEnterIcon /></span>
        <span className={styles.iconExit}><FullscreenExitIcon /></span>
      </button>
      <Tooltip label={isFullscreen ? 'Обычный режим' : 'Во весь экран'} shortcut="f" />
    </div>
  );
}
